module.exports = __webpack_public_path__ + "media/svgs/smiley-xx-loading-83101c91e5082c25cc104eaa068af8d9.svg";